import { ScrollingModule, CdkScrollable } from '@angular/cdk/scrolling';
import { CommonModule, DOCUMENT, isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, Inject, NgZone, OnInit, OnDestroy, ViewChild, PLATFORM_ID, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { FooterComponent } from '../../../shared/footer/footer.component';
import { CartQtyControlComponent } from '../../cart-qty-control/cart-qty-control.component';
import { ProdCardComponent } from '../prod-card/prod-card.component';
import { GridComponent } from '../product-grid1/grid/grid.component';
import { ProductCardComponent } from '../product-grid1/grid/product-card/product-card.component';
import { FiltersComponent } from '../product-grid2/filters/filters.component';
import { Breakpoints, MediaMatcher, BreakpointObserver } from '@angular/cdk/layout';
// import { AnimationItem } from 'lottie-web';
import { Observable, Subject, of, takeUntil } from 'rxjs';
import { Category, Item, ItemService } from '../../item-detail/item-detail.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AppMessageService } from '../../../app.message.service';
import { Meta, Title } from '@angular/platform-browser';
import { APPHOST } from '../../../app.component';

@Component({
  selector: 'app-product-grid3',
  standalone: true,
  imports: [CommonModule, GridComponent, MatTooltipModule, ScrollingModule, CdkScrollable, FooterComponent,
    MatSidenavModule, FiltersComponent, LottieComponent, RouterModule, ProdCardComponent, CartQtyControlComponent,
    ProductCardComponent, MatButtonModule, MatIconModule, MatToolbarModule],
  templateUrl: './product-grid3.component.html',
  styleUrl: './product-grid3.component.scss',
  changeDetection: ChangeDetectionStrategy.Default,
})
export class ProductGrid3Component implements OnInit, AfterViewInit, OnDestroy {
  slug = '';
  // items: Item[] = [];
  filteredItems: Item[] = [];
  // options: AnimationOptions = {
  //   path: '../../../assets/branding/empty.json',
  // };
  // animationItem!: AnimationItem;

  @ViewChild('drawer') drawer!: MatSidenav;
  mobileQuery!: MediaQueryList;
  destroyed = new Subject<void>();
  currentScreenSize!: string;
  QUALITY = '0.2'
  scrollPos: number = 0;
  displayNameMap = new Map([
    [Breakpoints.XSmall, 'XSmall'],
    [Breakpoints.Small, 'Small'],
    [Breakpoints.Medium, 'Medium'],
    [Breakpoints.Large, 'Large'],
    [Breakpoints.XLarge, 'XLarge'],
  ]);
  overFilter: boolean = false;
  cat?: Observable<string>;

  constructor(private itemService: ItemService, private titleService: Title,private meta: Meta,
    private _changeDetectorRef: ChangeDetectorRef,
    private route: ActivatedRoute, @Inject(DOCUMENT) private document: Document,
    private media: MediaMatcher, private ngZone: NgZone, private msgService: AppMessageService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private breakpointObserver: BreakpointObserver,
  ) {

  }
  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
       
      const content = this.document.querySelector('.gridc');
      content!.addEventListener('scroll', (e) => {
        this.scrollPos = (content!.scrollTop);
        this.msgService.pushNotification('SHOW_GO_TO_TOP', this.scrollPos)
        this._changeDetectorRef.detectChanges()

      }, { passive: true })

      this.media.matchMedia('(max-width: 840px)').addEventListener('change', (e) => {
        if (e.matches) {
          this.overFilter = true
        } else {
          this.overFilter = false

        }
        this._changeDetectorRef.detectChanges()
      })
      this.msgService.notificationAnnounced$.subscribe(e => {
        if (e.topic === 'SCROLL_TO_TOP') {
          content!.scrollTo({ top: 0 })
        }
        if (e.topic === 'HIDE_FILTER') {
          this.drawer.toggle()
        }
        this._changeDetectorRef.detectChanges()

      })

    }



    this.breakpointObserver
      .observe([
        Breakpoints.XSmall,
        Breakpoints.Small,
        Breakpoints.Medium,
        Breakpoints.Large,
        Breakpoints.XLarge,
      ])
      .pipe(takeUntil(this.destroyed))
      .subscribe(result => {
        this.mobileQuery = this.media.matchMedia('(max-width: 600px)');
        for (const query of Object.keys(result.breakpoints)) {
          if (result.breakpoints[query]) {
            const size = this.displayNameMap.get(query);
            // console.log(size)
            if (size === 'Medium' || size === 'Large' || size === 'XLarge') {
              this.drawer.open();
              // this.overFilter = false;
            }
            else {
              this.drawer.close();
              // this.overFilter = true;

            }
            this._changeDetectorRef.detectChanges()

            // this.currentScreenSize = this.displayNameMap.get(query) ?? 'Unknown';
          }
        }
      });
  }
  ngOnInit(): void {
    if (this.route.snapshot.data['items'] && Array.isArray(this.route.snapshot.data['items'])) {
      this.filteredItems = this.route.snapshot.data['items'];
    }
    this.route.data.pipe(takeUntil(this.destroyed)).subscribe(data => {
      if (data['items'] && Array.isArray(data['items'])) {
        this.filteredItems = data['items'];
        this._changeDetectorRef.detectChanges();
      }
    });
  }

  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  }

  handleLike(e: MouseEvent) {
    // Add these two lines
    e.stopPropagation();
    e.preventDefault();
    this._changeDetectorRef.detectChanges()

  }

  category(s: Category) {
    // this.cat = s.toUpperCase();
    this._changeDetectorRef.detach()
    this.cat = of(s.label!.toUpperCase())
    this._changeDetectorRef.reattach()
    this.titleService.setTitle(s.label!.toUpperCase()!)
    this.meta.addTag({ name: 'title', content: s.label!.toUpperCase()! });



    try {
      this.meta.removeTag('title');
      this.meta.removeTag('description');

      this.meta.removeTag('og:type');
      this.meta.removeTag('og:url');
      this.meta.removeTag('og:title');
      this.meta.removeTag('og:description');
      this.meta.removeTag('og:image');


      this.meta.removeTag('twitter:card');
      this.meta.removeTag('twitter:url');
      this.meta.removeTag('twitter:title');
      this.meta.removeTag('twitter:description');
      this.meta.removeTag('twitter:image');
      this.meta.removeTag('twitter:image');
    } catch (error) {

    }



var g=    'Looking for the latest '+ s.label!.toUpperCase()! +' in Sri Lanka?  Softnet Computers, Negombo, offers an extensive selection of top-rated '+ s.label!.toUpperCase()! +'  at competitive prices!  From powerful processors to stunning displays, we have everything you need to upgrade your home or office setup.  Shop online for fast islandwide delivery or visit our store in Negombo for expert advice!';

    this.meta.addTag({ name: 'description', content: g });

    this.meta.addTag({ property: 'og:type', content: 'website' });
    this.meta.addTag({ property: 'og:url', content: 'https://softnetcomputers.lk' + '/' + s.slug  });
    this.meta.addTag({ property: 'og:title', content: s.label! });
    this.meta.addTag({ name: 'og:description', content: g });
    this.meta.addTag({ name: 'og:image', content: encodeURI('http://softnetcomputers.lk' + '/' + s.icon!) });
    this.meta.addTag({ name: 'og:image:secure', content: encodeURI('https://softnetcomputers.lk' + '/' + s.icon!) });
    this.meta.addTag({ name: 'og:image:secure_url', content: encodeURI('https://softnetcomputers.lk' + '/' + s.icon!) });


    this.meta.addTag({ property: 'twitter:card', content: 'summary_large_image' });
    this.meta.addTag({ property: 'twitter:url', content: 'https://softnetcomputers.lk' + '/' +  s.slug  });
    this.meta.addTag({ property: 'twitter:title', content:  s.label!  });
    this.meta.addTag({ name: 'twitter:description', content: g });
    this.meta.addTag({ name: 'twitter:image', content: encodeURI('http://softnetcomputers.lk' + '/' + s.icon!) });
    this.meta.addTag({ name: 'twitter:image:secure', content: encodeURI('https://softnetcomputers.lk' + '/' + s.icon!) });


  }

  filterItems(items: Item[]) {
    this.filteredItems = items;
    this._changeDetectorRef.detectChanges()


  }

  playAudio(): void {
    this.ngZone.runOutsideAngular(() => {
      this.document.createElement('button').click()
      const audio = new Audio();
      audio.src = '../../../../assets/branding/tap2.mp3';
      // audio.volume=.10;
      audio.load();
      audio.play();
    })

  }


  urlAdjust(url?: string): string {
    if (url !== undefined) {
      url.replace('/image/thumb',  '/image/thumb/300/' + this.QUALITY)
      return APPHOST+'/'+url
    }
    return '';
  }

}
